
import { Vue, Component, Prop } from 'vue-property-decorator';
import { List } from 'vant';
import { getNewslist } from '@/api/api';
Vue.use(List);
@Component
export default class NewsList extends Vue {
  @Prop() voteName!: string;
  @Prop({ default: '资讯' }) title!: string;

  loading = false;
  finished = false;
  page = 1;
  getNewsList: any[] = [];
  loadingStatus = true;

  onLoad() {
    if (this.loadingStatus) {
      this.loadingStatus = false;
      setTimeout(() => {
        getNewslist(this.voteName, this.page).then((res) =>
          this.endNewsData(res),
        );
      }, 150);
    }
  }
  endNewsData(res: any) {
    if (!res.data) {
      this.finished = true;
    } else {
      this.getNewsList = [...this.getNewsList, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
    this.loadingStatus = true;
  }
  newsListWindowHref(item: any) {
    window.location.href = item.titleurl || item.targetUrl;
  }
}
